
export default {
  props: {
    tab: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ctaText() {
      return this.$te('download') ? this.$t('download') : 'DOWNLOAD'
    },
  },
}
